/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPortfel: {
  name: 'portfel';
  data: string;
} = {
  name: 'portfel',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 3a2 2 0 0 0-2 2v2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-4V5a2 2 0 0 0-2-2h-4Zm4 4V5h-4v2h4ZM9 9h6v10H9V9ZM7 19V9H4v10h3Zm10 0V9h3v10h-3Z" fill="currentColor"/></svg>`,
};
